/* Publish by EComposer at 2024-07-31 10:34:16*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-djh49d0kusq"]=  window.__ectimmers["ecom-djh49d0kusq"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-djh49d0kusq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djh49d0kusq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4z5daclq42k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4z5daclq42k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9r02gwlga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9r02gwlga', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-na7fhrktori').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-na7fhrktori', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k7in7aiudol').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k7in7aiudol', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mjfomz4any').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mjfomz4any', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhg4sdbofb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhg4sdbofb6', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0lq191a8pq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0lq191a8pq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8td98iuw8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8td98iuw8j', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-no6tn89trho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-no6tn89trho', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dxp90r7pqte').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dxp90r7pqte', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t2ytai3o3br').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t2ytai3o3br', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}